import { useI18n } from '@cascade/react/i18n';
import { Button, Input } from '@cascade/ui-library';
import { useState } from 'react';
import type { FormEvent } from 'react';
import { isValidLoginEmail } from '@cascade/core/auth';
import classes from './EmailForm.module.scss';
import type { TEmailFormProps } from './EmailForm.types.ts';

export const EmailForm = ({ errorMessage, onSubmit }: TEmailFormProps) => {
  const { translate } = useI18n();
  const [email, setEmail] = useState('');
  const [hasBlurred, setHasBlurred] = useState(false);

  const isValid = isValidLoginEmail(email);
  const showInvalid = hasBlurred && email.length > 0 && !isValid;
  const feedback =
    errorMessage ??
    (showInvalid ? translate('signIn.emailInvalid') : undefined);

  const changeEmail = (value: string) => {
    setEmail(value);
    setHasBlurred(false);
  };

  const submitEmail = () => {
    if (!isValid) {
      return;
    }

    onSubmit(email.trim());
  };

  const submitForm = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    submitEmail();
  };

  return (
    <form className={classes['email-form']} onSubmit={submitForm} noValidate>
      <Input
        label={translate('signIn.email')}
        placeholder={translate('signIn.emailPlaceholder')}
        type='email'
        value={email}
        required
        autoComplete
        feedbackLevel={feedback ? 'danger' : undefined}
        feedbackText={feedback}
        onChange={changeEmail}
        onBlur={() => setHasBlurred(true)}
      />
      <Button
        label={translate('signIn.submit')}
        disabled={!isValid}
        onClick={submitEmail}
      />
    </form>
  );
};
